import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { VersionCheckService } from '@/common/services';

@Component({
  selector: 'app-update-banner',
  standalone: true,
  imports: [TranslateModule],
  template: `
    @if (versionCheck.updateAvailable()) {
      <div class="update-banner">
        <span class="update-banner__message">
          {{ 'COMMON.UPDATE_BANNER.MESSAGE' | translate }}
          <a class="update-banner__link" (click)="reload()">{{ 'COMMON.UPDATE_BANNER.ACTION' | translate }}</a>
        </span>
      </div>
    }
  `,
})
export class UpdateBannerComponent {
  readonly versionCheck = inject(VersionCheckService);

  reload(): void {
    window.location.reload();
  }
}

